export class CanidateAssessment {
    AnswerId: number;
    AnswerText: string;
    QuestionId: number;
    QuestionText: string;
    QuestionType: number;
    Multiplechoice: number;
    Coding: boolean;
}